import styled from '@emotion/styled';
import { Chip } from '@mui/material';
import { DateTime } from 'luxon';
import { isEmpty } from 'lodash';

import useTableStore from '../../../../store/table';

// useContext hook to access the table store
import { useTableId } from '../../../../contexts/TableId'; // Uncomment if needed

const CustomChip = styled(Chip)`
  .label {
    font-weight: 700;
  }
`;


const formatValue = (value) => {
  if (typeof value === 'number') {
    return value;
  }
  
  // Skip processing for values that definitely aren't dates
  if (value === null || value === undefined || typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    // Only process string values that match date-like patterns
    // This regex checks for ISO-like date strings: YYYY-MM-DD or YYYY/MM/DD
    const datePattern = /^\d{4}[-/]\d{1,2}[-/]\d{1,2}(T|\s|$)/;
    if (!datePattern.test(value)) {
      return value;
    }
  }
  
  const dateTime = DateTime.fromJSDate(new Date(value));
  if (dateTime.isValid) {
    return dateTime.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
  }
  // Return original value if not a valid date
  return value;
};

const getLabel = (val = {}, label) => {
  let str = '';
  if (val.$eq !== undefined) {
    str = `${formatValue(val.$eq)}`;
  } else if ((val.$gte !== undefined || val.$gt !== undefined) && val.$lte !== undefined) {
    str = `${formatValue(val.$gte || val.$gt)} - ${formatValue(val.$lte)}`;
  } else if ((val.$gte !== undefined || val.$gt !== undefined)) {
    str = `${formatValue(val.$gte || val.$gt)} -`;
  } else if (val.$lte !== undefined) {
    str = `- ${formatValue(val.$lte)}`;
  } else if (val.$in !== undefined) {
    str = `${val.$in.join(', ')}`;
  } else {
    str = JSON.stringify(val);
  }

  if (label) {
    str = <span><span className='label'>{label}</span>: {str}</span>;
  }
  
  // Fallback in case none of the expected properties are found
  return str;
}


const FilterChip = ({id, label, filter}) => {
  const tableId = useTableId(); 
  const resetFilters = useTableStore(state => state.resetTableFilters);
  if (isEmpty(filter)) return null;

  let refresh = label ? true : false;

  return (
    <CustomChip label={getLabel(filter, label)} size="small" variant="outlined" color="secondary" onDelete={() => resetFilters(tableId, id, null, refresh)} />
  );
};

export default FilterChip;
